

export class Employee_NewDashboard_BasicDetailDto implements IEmployee_NewDashboard_BasicDetailDto {
    totalTDSAmount!: number | undefined;
    nextIncrementDate!: Date | undefined;
    totalInvestmentAmount!: number | undefined;
    averageSalary!: number | undefined;

    constructor(data?: IEmployee_NewDashboard_BasicDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalTDSAmount = _data["totalTDSAmount"];
            this.nextIncrementDate = _data["nextIncrementDate"] ? new Date(_data["nextIncrementDate"].toString()) : <any>undefined;
            this.totalInvestmentAmount = _data["totalInvestmentAmount"];
            this.averageSalary = _data["averageSalary"];
        }
    }

    static fromJS(data: any): Employee_NewDashboard_BasicDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new Employee_NewDashboard_BasicDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalTDSAmount"] = this.totalTDSAmount;
        data["nextIncrementDate"] = this.nextIncrementDate ? this.nextIncrementDate.toISOString() : <any>undefined;
        data["totalInvestmentAmount"] = this.totalInvestmentAmount;
        data["averageSalary"] = this.averageSalary;
        return data; 
    }
}

export interface IEmployee_NewDashboard_BasicDetailDto {
    totalTDSAmount: number | undefined;
    nextIncrementDate: Date | undefined;
    totalInvestmentAmount: number | undefined;
    averageSalary: number | undefined;
}

